import type { LoginAsCustomerResult } from 'src/interfaces/customer'

/**
 * Builds the dashboard "sign in as customer" URL. The dashboard's `SignInAsPage` reads
 * `token` and `refreshtoken` (lowercase) query params — see
 * `apps/dashboard/src/pages/auth/SignInAsPage.tsx`. Both values are URL-encoded since a
 * token can contain characters (`+`, `/`) that are not safe to place in a query string
 * unescaped.
 */
export const buildSignInAsUrl = (dashboardUrl: string, tokens: LoginAsCustomerResult): string => {
  const encodedAccessToken = encodeURIComponent(tokens.accessToken)
  const encodedRefreshToken = encodeURIComponent(tokens.refreshToken)

  return `${dashboardUrl}/sign-in-as?token=${encodedAccessToken}&refreshtoken=${encodedRefreshToken}`
}
